<div class="content " fxLayout="column wrap" *ngIf="set1">
    <div class="headContent " fxFlex="100">
        <span class="head shimmer">
            <b>Content head loading.. </b>
        </span>
    </div>
    <div fxFlex="100" class="inputs input" fxLayout="column">
        <div class="loadingInput1 shimmer">
        </div>
        <div class="loadingInput1 shimmer">
        </div>
    </div>
</div>
<div class="content " fxLayout="column wrap" *ngIf="set2">
    <div class="headContent " fxFlex="100">
        <span class="head shimmer">
            <b>Content head loading.. </b>
        </span>
    </div>
    <div fxFlex="100" class="inputs input" fxLayout="row wrap">
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
    </div>
</div>
<div class="content1" fxLayout="column wrap" *ngIf="set3">
    <div fxFlex="100" class="input" fxLayout="row wrap">
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
    </div>
</div>
<div fxLayout="column wrap" *ngIf="set3a">
    <div fxFlex="100" class="input" fxLayout="row wrap">
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
    </div>
</div>

<div class="content1" fxLayout="column wrap" *ngIf="set4">
    <span class="head shimmer">
        <b>this is the loading content which is under progress.. expect you patience while it loads.. Thanks </b>
    </span>
    <div fxFlex="100" class="actionButton" fxLayout="row wrap">
        <div class="loadingInput shimmer">
        </div>
        <div class="loadingInput shimmer">
        </div>
    </div>
</div>

<div class="content1" fxLayout="column wrap" *ngIf="set5">
    <span class="head shimmer">
        <b>The timeline header loading..</b>
    </span>
    <div fxFlex="100" class="inputs input" fxLayout="row wrap">
        <div class="loadingInput shimmer" fxFlex="100">
        </div>
        <div class="loadingInput shimmer" fxFlex="100">
        </div>
        <div class="loadingInput shimmer" fxFlex="100">
        </div>
        <div class="loadingInput shimmer" fxFlex="100">
        </div>
        <div class="loadingInput shimmer" fxFlex="100">
        </div>
        <div class="loadingInput shimmer" fxFlex="100">
        </div>
        <div class="loadingInput shimmer" fxFlex="100">
        </div>
    </div>
</div>

<div class="content2" fxLayout="column wrap" *ngIf="set6">
    <div fxFlex="100" class="input2" fxLayout="row wrap">
        <ng-container *ngFor=" let a of numbers">
            <div class="loadingInput shimmer" fxFlex="100">
            </div>
        </ng-container>
        <!-- <div class="loadingInput shimmer" fxFlex="100">
        </div>
        <div class="loadingInput shimmer" fxFlex="100">
        </div>
        <div class="loadingInput shimmer" fxFlex="100">
        </div>
        <div class="loadingInput shimmer" fxFlex="100">
        </div>
        <div class="loadingInput shimmer" fxFlex="100">
        </div>
        <div class="loadingInput shimmer" fxFlex="100">
        </div> -->
    </div>
</div>

<div class="content3" *ngIf="set7">
    <div class="leftContent" fxFlex="68%">
        <div class="chatHeader shimmer">head</div>
        <div class="messageBox shimmer">message</div>
        <div class="chatInput shimmer">input</div>
    </div>
    <div class="rightContent" fxFlex="30%">
        <div class="participants shimmer">Participants</div>
        <div class="documents shimmer ">documents</div>
    </div>

</div>

<div *ngIf="set8">
    <span class="head shimmer">
        <b>this is the loading content which is under progress.. expect you patience while it loads.. Thanks </b>
    </span>
</div>

<div class="contentTicket " *ngIf="set9">
    <div class="ticketHead">
        <div class="inititals shimmer">
            <logzy-img-loader border_radius="50%" fontSize="14px" [class.p-0]="true" [background_color]="'#f9bda5'"
                class="profile-logo-round shimmer" [span_color]="'#ffffff'">
            </logzy-img-loader>
        </div>
        <div class="headText">
            <div fxLayout="column" class="gap-1">
                <span class="line1 shimmer">


                </span>
                <div class="title shimmer">
                    this is the loading content which is under progress..
                </div>
            </div>
            <div class="status shimmer">
                <span class="sleek-chip">
                    this is the loading content which is under progress.. </span>
                <div class=" shimmer">

                </div>
            </div>
        </div>
    </div>
    <div class="ticketContent" fxLayout="column">
        <div class="description shimmer">
            this is the loading content which is under progress..
        </div>
        <div class="shadowing shimmer"></div>
    </div>
    <div class="ticketFoot ml12">
        <div fxLayout="row wrap" class="likeComment">
            <i class="flaticon-like shimmer">XX</i>

            <i class="flaticon-dislike shimmer">XX</i>
            <i class="flaticon-dislike shimmer">XX</i>
            <i class="flaticon-conversation commentshow shimmer">
            </i>

        </div>

        <div class="date shimmer">
            XX-XX-XXXX
        </div>
    </div>
</div>
